// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role"); //N Guarda el IdRol al iniciar sesión para que no se pierda el inicio de sesiòn 

  if (!token) {
    // No autenticado
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(Number(userRole))) {
    // Rol no permitido
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;